module.exports = __webpack_public_path__ + "media/logos/facebook-8f87e65c.png";